import { getDeeplink, setDeeplink } from '~/misc/getQuery';
import { platformParser, mobileSearchBuiler } from '~/pages/EmailCampaignNew/uilts';
import { getTempStorge, set } from './metrics/timeLimitMetric';

const addMetric = () => {
  const metricData = getTempStorge();
  if(metricData.message_id && metricData.message_id.length) {
    const {
      campaign_content,
      original_source,
      message_id  
    } = metricData
    return `original_source=${original_source}&message_id=${message_id}&campaign_content=${campaign_content}`
  }
  return ''
}

class Deeplink {
  openDetail({id}) {
    return (platformParser() === 'Ios' ? `truckloads://shipment?shipmentId=${id}` : `truckloads://shipment?id=${id}`) + '&' + addMetric();
  }

  setSearch(loadInfo) {
    return setDeeplink( `truckloads://Loadlist_filter${mobileSearchBuiler(loadInfo)}`);
  }
  openSearch({hash}) {
    return getDeeplink(hash) + '&' + addMetric();
  }

  setPostTruck(loadInfo) {
    return setDeeplink( `truckloads://addNewPostTruck${mobileSearchBuiler(loadInfo)}`);
  }
  openPostTruck({hash}) {
    return getDeeplink(hash) + '&' + addMetric();
  }

  setRateCheck(loadInfo) {
    return setDeeplink( `truckloads://rateCheck${mobileSearchBuiler(loadInfo)}`);
  }
  openRateCheck ({hash}) {
    return getDeeplink(hash) + '&' + addMetric();
  }
  setCapacityRatio (loadInfo) {
    return setDeeplink( `truckloads://capacityRatio${mobileSearchBuiler(loadInfo)}`);
  }
  openCapacityRatio ({hash}) {
    return getDeeplink(hash) + '&' + addMetric();
  }
  setCapacityIndicator (loadInfo) {
    return setDeeplink( `truckloads://capacityIndicator${mobileSearchBuiler(loadInfo)}`);
  }
  openCapacityIndicator ({hash}) {
    return getDeeplink(hash) + '&' + addMetric();
  }
}

const deeplink = new Deeplink();
export default deeplink






// WEBPACK FOOTER //
// ./src/misc/deeplink.js